import * as React from 'react'

import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground flex field-sizing-content min-h-30 w-full rounded-xl border bg-input p-3 text-base transition-[color] outline-none',
        'focus-visible:border-primary hover:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:border-input',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
